import "./Home.css";
import ComponentIcon from "../../assets/ComponentIcon.png";
import ScanIcon from "../../assets/ScanIcon.png";
import SDKIcon from "../../assets/SDKIcon.png";
import UIIcon from "../../assets/UIIcon.png";

import React, { useState } from "react";

import SpiralDots from "../../components/SpiralDots/SpiralDots";
import Social from "../../components/Social/Social";
import Protocols from "../../components/Protocols/Protocols";
import Aser from "../../components/Aser/Aser";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
function Home() {


  return (
    <div className="Home">
      <Header></Header>
      <div className="Introduce">
        <div className="IntroduceContent">
          <h1>A connector between onchain Apps and AI</h1>

          <p>
            Ame Network provides a comprehensive suite of tools designed to
            streamline the integration of AI into onchain ecosystems. It enables
            developers to build decentralized applications with AI capabilities.
          </p>
          <a
            href="https://docs.ame.network/"
            target="_blank"
            className="LearnMoreButton"
          >
            Start Building
          </a>
        </div>

        <div className="IntroduceImage">
          <SpiralDots></SpiralDots>
        </div>
      </div>

      <div className="OnchainKit" id="onchainstack">
        <div className="OnchainKitTitle">Onchain Stack</div>

        <ul className="OnchainKitItems">
          <li>
            <a
              href="https://github.com/AmeNetwork/ame-component"
              target="_blank"
            >
              <div className="OnchainKitItemTitle">
                <img src={ComponentIcon} width={24} />
                <p>Ame Component</p>
              </div>
              <div className="OnchainKitItemDetail">
                Ame Component is an onchain component that decomposes complex
                onchain processes into independent, composable, reusable, and
                highly adaptable functional units.
              </div>
            </a>
          </li>
          <li>
            <a href="https://github.com/AmeNetwork/ame-sdk" target="_blank">
              <div className="OnchainKitItemTitle">
                <img src={SDKIcon} width={24} />
                <p>Ame SDK</p>
              </div>
              <div className="OnchainKitItemDetail">
                A JavaScript Development Kit for Seamless Interaction with Ame
                Network
              </div>
            </a>
          </li>
          <li>
            <a href="https://scan.ame.network/" target="_blank">
              <div className="OnchainKitItemTitle">
                <img src={ScanIcon} width={24} />
                <p>Ame Scan</p>
              </div>
              <div className="OnchainKitItemDetail">
                A Manager for Viewing Components Across Multiple Networks
              </div>
            </a>
          </li>
          <li>
            <a href="https://github.com/AmeNetwork/ame-ui" target="_blank">
              <div className="OnchainKitItemTitle">
                <img src={UIIcon} width={24} />
                <p>Ame UI</p>
              </div>
              <div className="OnchainKitItemDetail">
                Ame UI is a lightweight React component library that helps
                developers quickly build Onchain applications and AI Agent
                interaction interfaces.
              </div>
            </a>
          </li>
        </ul>
      </div>

      <div id="protocols">
        <Protocols></Protocols>
      </div>

      <div id="agent">
        <Aser></Aser>
      </div>

      <Social></Social>
      <Footer></Footer>
    </div>
  );
}
export default Home;
